import React from "react";

import { companyAudit } from "../../services/companyAudit";
import { AuditStore } from "../CompanyList";

import { JsonBlock, JsonFieldLabel, JsonItem, JsonItemTitle } from "./styles";

const tryParseJson = (value: string): any => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed.startsWith("[") && !trimmed.startsWith("{")) return null;
  try {
    return JSON.parse(trimmed);
  } catch {
    return null;
  }
};

const toItems = (data: any): any[] =>
  data == null ? [] : Array.isArray(data) ? data : [data];

const collectKeys = (...datas: any[]): string[] => {
  const keys: string[] = [];
  datas.forEach((data) =>
    toItems(data).forEach((item) =>
      Object.keys(item ?? {}).forEach((key) => {
        if (!keys.includes(key)) keys.push(key);
      })
    )
  );
  return keys;
};

const renderJson = (data: any, keys: string[]) => {
  if (data == null) return <span>—</span>;

  return toItems(data).map((item, index) => (
    <JsonItem key={index}>
      {keys.map((key) => {
        const value = item?.[key];
        return (
          <span key={key}>
            <JsonFieldLabel>{key}</JsonFieldLabel>{" "}
            {value === null || value === undefined ? "—" : String(value)}
          </span>
        );
      })}
    </JsonItem>
  ));
};

interface IProps {
  record: AuditStore;
}

const AuditChangeValue: React.FC<IProps> = ({ record }) => {
  const oldJson = tryParseJson(record.old_value);
  const newJson = tryParseJson(record.new_value);

  if (oldJson == null && newJson == null) {
    return <span>{companyAudit(record)}</span>;
  }

  const keys = collectKeys(oldJson, newJson);

  return (
    <JsonBlock>
      <JsonItemTitle>Anterior</JsonItemTitle>
      {renderJson(oldJson, keys)}
      <JsonItemTitle>Atual</JsonItemTitle>
      {renderJson(newJson, keys)}
    </JsonBlock>
  );
};

export default AuditChangeValue;
